import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'automationTemplate/<id>';

export function useAutomationTemplateIdQuery({
	id,
	enabled = true,
	impersonationContext,
}: {
	id: string;
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
}) {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<Api.IAutomationTemplate>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `automationTemplate/${encodeURIComponent(id)}`,
					impersonationContext,
				}),
				'GET'
			);
		},
		queryKey: [BASE_QUERY_KEY, id],
	});
}

export function invalidateAllAutomationTemplateIdQueries() {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
}
